import { Carousel } from "react-bootstrap"
import { url_images } from "../../lib/backend/data"

const { useSelector } = require("react-redux")

const MessageTop = props => {
    const {
        zone
    } = props
    const sitio = useSelector(state => state.sitio)
    if(sitio.modules?.topbar_message.active !== true) return null
    if(!sitio.modules?.topbar_message?.items?.message?.value) return null
    
    const estilo_contenedor = {}
    const estilo_titulo = {}
    if(sitio.modules?.topbar_message?.items?.color?.value) estilo_titulo.color = sitio.modules?.topbar_message?.items?.color?.value
    if(sitio.modules?.topbar_message?.items?.font_size?.value) estilo_titulo.fontSize = sitio.modules?.topbar_message?.items?.font_size?.value
    if(sitio.modules?.topbar_message?.items?.background?.value) estilo_contenedor.background = sitio.modules?.topbar_message?.items?.background?.value

    return <div style={estilo_contenedor} className="p-3 text-center">
        <h6 style={estilo_titulo} className="mb-0">{sitio.modules?.topbar_message?.items?.message?.value}</h6>
    </div>
}

export default MessageTop